import { Injectable } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})
export class PanelAnimationsService {
  constructor() { }

  static getRightPanelAnimation(openPercent:number,animationTime:string ='0' ) {
    return trigger(
      'rightPanelAnimation',
      [
        state('*',style({
          position: 'fixed',
          top: '0',
          right: '0', /* Panel başlangıçta tamamen ekranın dışında */
          width: `${openPercent}%`,
          height: '100%',
          backgroundColor: 'var(--base-bg-darken-5)',
          'z-index': 9999,
          'box-shadow': '-2px 0 5px rgba(0, 0, 0, 0.5)'
        })),
        transition(
        ':enter',
          [
            style({ width: 0, opacity: 0 }),
            animate( animationTime +'s ease-out',
                    style({ width: `${openPercent}%`, opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ width: `${openPercent}%`, opacity: 1 }),
            animate(animationTime +'s ease-in',
                    style({ width: 0, opacity: 0 }))
          ]
        )
      ]
    )
  }
}
